// extracted by mini-css-extract-plugin
export default {"container1":"Success_container1__ppPfe"};